import { useQuery } from "@tanstack/react-query"
import { illustrationResult } from "../api/illustrationResult"

const useIllustrationResult = ({ page, limit, sortBy, filters }) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["illustration-result", page, limit, sortBy, filters],
    queryFn: () => illustrationResult({ page, limit, sortBy, filters }),
    retry: false,
  })

  return {
    data,
    isLoading,
    isError,
    error,
  }
}

export default useIllustrationResult
